import { ADD_IMAGE, DELETE_IMAGE, CARREGAR_IMAGES_SERVER, MODIFY_IMAGE_DESC } from "../constants/constants";
import {storage, database} from '../firebase'
import {doLoad, finishLoad} from '../actions/request'
import { adicionarImagemStore, deletarImagemStore, carregarImagensNaStore } from "../actions/imagem";

export default ({dispatch}) => next => action =>{
    let sref;
    
    if(action.type == CARREGAR_IMAGES_SERVER){
        dispatch(doLoad());
            database.ref('/imagens/').on('value', (snap)=>{
                dispatch(finishLoad())
                let dval = snap.val() || []
                let _val = [];
                for(let e in dval){
                    _val.push(dval[e]);
                }
                dispatch(carregarImagensNaStore(_val.filter(x=>x!=undefined)));
            })
    }

    if(action.type == ADD_IMAGE){
        dispatch(doLoad());
        let ssref = storage.ref('/imagensDoLocal/').child(action.id+'.jpg').put(action.img);
        ssref.on('state_changed', ()=>{}, (error)=>{
            console.log('error durante upload de ',action.name, ': ', error)
        }, ()=>{
            ssref.snapshot.ref.getDownloadURL().then((downloadURL)=> {
                action.name = action.img.name
                action.img = downloadURL;                    
                database.ref('/imagens/').once('value', snap =>{                                               
                    let update = {};
                    let {img, desc, id} = action;
                    update['/imagens/'+ action.id] =  {img, desc, id};
                    database.ref().update(update);   
                    dispatch(finishLoad());
                    dispatch(adicionarImagemStore(action.img, action.desc, action.id));
                    next(action);
                })                    
            });
        })
    }

    if(action.type == DELETE_IMAGE){
        dispatch(doLoad())
        sref = storage.ref('/imagensDoLocal/'+action.id+'.jpg');

        sref.delete().then(()=>{      

            database.ref('/imagens/').once('value', snap =>{
                dispatch(finishLoad());
                let val = snap.val();
                let update = {};
                update['/imagens/'] = val
                delete update['/imagens/'][action.id];
                database.ref().update(update);
            })
            dispatch(deletarImagemStore(action.id)) 

        })
        .catch((err) => {console.log(err)})
    }

    if(action.type == MODIFY_IMAGE_DESC){
        database.ref('/imagens/').once('value', snap =>{                                               
            let update = {};
            let {desc} = action;
            update['/imagens/'+ action.id] =  {...snap.val()[action.id], desc};
            database.ref().update(update);   
            dispatch(finishLoad());
            next(action);
        })    
    }
        
    next(action);
    
}


// WEBPACK FOOTER //
// ./src/middlewares/imagens.js